/**
 * Explicit workspace-wide scope flag (query/body `scope`). The only value is `shared`, signalling that a
 * list/create/update should target workspace-wide (not-branch-bound) entities. Branch vs parish scope is
 * never expressed here. It is derived from the request's resolved branch (SYSTEM branch is parish,
 * NORMAL branch is branch), exactly like finance/members/assets.
 */
export enum WorkspaceScope {
  Shared = "shared",
}

/** Mirrors Prisma `BranchType`. */
export enum BranchType {
  Normal = "NORMAL",
  System = "SYSTEM",
}

/** Parish / branch record availability for finance configuration surfaces. */
export enum RecordAvailability {
  BranchOnly = "BRANCH_ONLY",
  ParishOnly = "PARISH_ONLY",
  SharedWithBranches = "SHARED_WITH_BRANCHES",
}
